import { useCallback } from 'react';
import { useMaintenanceHistoryQuery } from '../../maintenance.queries';

// STD-016: thin wrapper over the TanStack `useMaintenanceHistoryQuery`. The
// previous hand-rolled `window` CustomEvent bus (maintenance-record-*) is gone —
// mutations invalidate the upcoming/history keys and TanStack auto-refetches.
export const useMaintenanceHistory = (droneSerial?: string) => {
  const query = useMaintenanceHistoryQuery(droneSerial);
  const { refetch } = query;

  const refresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    maintenanceHistory: query.data ?? [],
    loading: query.isFetching,
    error: query.isError ? 'Failed to load maintenance history' : null,
    refresh,
  };
};
